import { graphql, Link, useStaticQuery } from 'gatsby';
import React, { useMemo, useState } from 'react';
import { convertResourceCategoryToPageSlug } from 'src/functions/resouceCategoryToSlug';
import ResourceCenterMobileMenu from 'src/molecules/articles/resourceCenter/resourceCenter.menuMobile';
import { ResourceCenterMenuLinkGroup, ResourceCenterMenuLinkSubGroup, ResourceCenterMenuContainer, ResourceCenterMenuLinks, ResourceCenterMenuLinkSubEntry, ResourceCenterMenuLinkPost, ResourceCenterMenuLinksMobile } from './resourceCenter.menu.styles';

interface ResourceCenterMenuData {
  allContentfulResource: {
    edges: {
      node: {
        subCategory: string;
        category: string;
        slug: string;
        title: string;
      }
    }[]
  }
}

const ResourceCenterMenu = (): JSX.Element => {

  const [ mobileOpened, setMobileOpened ] = useState(false);

  const { allContentfulResource: data }: ResourceCenterMenuData = useStaticQuery(graphql`
  query ContentfulResourceMenuQuery {
    allContentfulResource(sort: {fields: createdAt, order: DESC}) {
      edges {
        node {
          subCategory
          category
          slug
          title
        }
      }
    }
  }`)

  const menuCategorizedGroup = useMemo(() => {
    return data.edges.reduce((p, { node }) => {
      if (node.category) {
        if (p[ node.category ]) {
          const category = p[ node.category ];
          if (category[ node.subCategory ]) {
            category[ node.subCategory ].push({ title: node.title, slug: node.slug });
          } else {
            category[ node.subCategory ] = [ { title: node.title, slug: node.slug } ];
          }
        } else {
          const subCatDict: { [ key: string ]: { title: string; slug: string }[] } = {};
          subCatDict[ node.subCategory ] = [ { title: node.title, slug: node.slug } ];
          p[ node.category ] = subCatDict;
        }
      }
      return p;
    }, {} as { [ key: string ]: { [ key: string ]: { title: string; slug: string }[] } })
  }, [ data ])

  const toggleMobile = () => {
    setMobileOpened(toggle => !toggle);
  }

  return (
    <>
      <ResourceCenterMenuContainer>
        <ResourceCenterMenuLinks>
          {
            Object.keys(menuCategorizedGroup).sort((a, b) => a.localeCompare(b)).map((category, index) => {
              const categoryGroup = menuCategorizedGroup[ category ];
              const orientation = (index / Object.keys(menuCategorizedGroup).length) > 0.5 ? 'left' : 'right';
              return (
                <ResourceCenterMenuLinkGroup key={category}>
                  <Link to={`/resources/${convertResourceCategoryToPageSlug(category)}`}>
                    {category}
                  </Link>
                  <ResourceCenterMenuLinkSubGroup orientation={orientation}>
                    {
                      Object.keys(categoryGroup).sort((a, b) => a.localeCompare(b)).map((subcategory => (
                        <ResourceCenterMenuLinkSubEntry key={subcategory}>
                          <Link to={`/resources/${convertResourceCategoryToPageSlug(category)}/${convertResourceCategoryToPageSlug(subcategory)}`}>
                            <span>
                              {subcategory}
                            </span>
                          </Link>
                          <ResourceCenterMenuLinkPost orientation={orientation}>
                            {
                              categoryGroup[ subcategory ].filter((_post, postIndex) => postIndex < 5).map((post) => (
                                <ResourceCenterMenuLinkSubEntry key={post.slug} >
                                  <Link to={`/resources/${post.slug}`}>
                                    {post.title}
                                  </Link>
                                </ResourceCenterMenuLinkSubEntry>
                              ))
                            }
                            {
                              categoryGroup[ subcategory ].length >= 5 ?
                                <ResourceCenterMenuLinkSubEntry >
                                  <Link to={`/resources/${convertResourceCategoryToPageSlug(category)}/${convertResourceCategoryToPageSlug(subcategory)}`}>
                                    View All
                                  </Link>
                                </ResourceCenterMenuLinkSubEntry>
                                : null
                            }
                          </ResourceCenterMenuLinkPost>
                        </ResourceCenterMenuLinkSubEntry>
                      )))
                    }
                  </ResourceCenterMenuLinkSubGroup>
                </ResourceCenterMenuLinkGroup>
              )
            })
          }
        </ResourceCenterMenuLinks>
        <ResourceCenterMenuLinksMobile>
          <ResourceCenterMenuLinkGroup>
            <a onClick={toggleMobile}>
              View All Articles
            </a>
          </ResourceCenterMenuLinkGroup>
        </ResourceCenterMenuLinksMobile>
      </ResourceCenterMenuContainer>
      <ResourceCenterMobileMenu opened={mobileOpened} links={menuCategorizedGroup} onOverlayClick={toggleMobile} />
    </>
  )
}

export default ResourceCenterMenu;
